// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__J0u7C","planConnectorIcon":"ConfirmStep_planConnectorIcon__jCreP"};